import { combineReducers } from 'redux';
import dataReducer, { AppData } from './data';
import sharedDataReducer, { AppSharedData } from './sharedData';
import uiReducer, { AppUI } from './ui';
import userReducer, { AppUser } from './user';

/*
  data: Domain data that is either specific to or private to the current user
  sharedData: Domain data that has been shared globally or directly with the current user. For globally shared resources, there may be no current
    authenticated user -- this is publicly accessible data.
  ui: Ephemeral UI state, which may be populated with some domain state from the user's domain data (`data`) or shared domain data
*/
export interface AppState {
  data: AppData;
  sharedData: AppSharedData;
  ui: AppUI;
  user: AppUser;
}

const rootReducer = combineReducers({
  data: dataReducer,
  sharedData: sharedDataReducer,
  ui: uiReducer,
  user: userReducer,
});

export default rootReducer;
